<template>
  <div>
    <Breadcrumbs :breaditems="breaditems" />

    <section class="cards">
      <div class="container">
        <div class="cards_wrap">
          <div class="section_top">
            <h1 v-text="$i18n.t('catalog.promotions_title')" />
          </div>
          <div class="cards_tabs_wrap page_tabs_wrap">
            <div class="cards_tabs_list page_tabs_list">
              <nuxt-link :to="localePath('promotions') + '/'" class="cards_tab page_tab active" v-text="$i18n.t('catalog.promotions_title')" />
              <nuxt-link :to="localePath('discounts') + '/'" class="cards_tab page_tab" v-text="$i18n.t('catalog.discounts_title')" />
            </div>
          </div>
          <div class="cards_content">
            <div class="cards_content_item page_content_item active">
              <div class="cards_list_wrap">
                <div class="cards_list">
                  <PromotionItem v-for="(item, index) in sales" :key="`${index}_sale`" :promotion="item" />
                </div>
                <!--pagination-->
                <Pagination :pagiitems="pagiitems" />
                <!--pagination-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <CarouselProducts :ext="{ products: noveltyList, title: $t('product.latest_products'), type: 'products', id: 'novelty', class: 'category_widget', link: localePath('novelties') + '/' }" />
  </div>
</template>
<script>
import Breadcrumbs from '../../components/Breadcrumbs'
import Pagination from '../../components/Pagination'
import PromotionItem from '../../components/product/PromotionItem'
import CarouselProducts from '../../components/modules/CarouselProducts'

export default {
  components: {
    Breadcrumbs,
    PromotionItem,
    CarouselProducts,
    Pagination
  },
  transition: {
    name: 'intro',
    afterLeave (el) {
      this.$nuxt.$emit('mm_hide')
    }
  },
  async asyncData ({ app, query, error }) {
    try {
      const par = {
        page: query.page
      }
      const sales = await app.$axios.$get('/api/promo/sales/', { params: par })
      const novelty = await app.$axios.$get('/api/promo/products/', { params: { catalog_type: 'novelty', only_new: 1, per_page: '5' } })
      return {
        sales: sales.data,
        pagination: sales.meta,
        novelty: novelty.data
      }
    } catch (err) {
      return error({
        statusCode: err.response ? err.response.status : 422,
        message: err.message,
        pageTitle: app.i18n.t('catalog.promotions_title')
      })
    }
  },
  data () {
    return {
      debug: '',
      loading: false,
      sales: [],
      novelty: null,
      pagination: {
        current_page: 1,
        from: 1,
        last_page: 1,
        links: [],
        path: '',
        per_page: 18,
        to: 2,
        total: 0
      }
    }
  },
  head () {
    const i18nHead = this.$formatSeoTags(
      this.$nuxtI18nHead({ addSeoAttributes: { canonicalQueries: ['page'] } }),
      'enabled',
      this.pageCanonical
    )
    return {
      htmlAttrs: {
        ...i18nHead.htmlAttrs
      },
      title: this.$i18n.t('catalog.promotions_title'),
      meta: [
        { hid: 'description', name: 'description', content: this.$i18n.t('catalog.promotions_description') },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:title', content: this.$i18n.t('catalog.promotions_title') },
        { property: 'og:description', content: this.$i18n.t('catalog.promotions_description') },
        { property: 'og:url', content: process.env.API_URL_BROWSER + this.$nuxt.$route.fullPath },
        { property: 'og:image', content: process.env.API_URL_BROWSER + '/icons/logo.svg' },
        ...i18nHead.meta
      ],
      link: [
        ...i18nHead.link
      ]
    }
  },
  computed: {
    breaditems () {
      return [
        {
          to: 'index',
          exact: true,
          text: this.$i18n.t('breadcrumbs.home'),
          alt: this.$i18n.t('breadcrumbs.home_in_breadcrumbs')
        },
        {
          to: 'promotions',
          disable: true,
          text: this.$i18n.t('catalog.promotions_title')
        }
      ]
    },
    pagiitems () {
      return this.pagination
    },
    pageCanonical () {
      return process.env.API_URL_BROWSER + this.localePath({ name: 'promotions' }) + '/'
    },
    noveltyList () {
      return this.novelty && this.novelty.length ? this.novelty : null
    }
  },
  mounted () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  }
}
</script>
